import React from "react";

const ToraAvatar: React.FC = () => {
  return (
    <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center overflow-hidden">
      <img
        src="https://imagedelivery.net/-nMEN5vW69LWTqJjOcxQog/ac16a3d6-35e6-4255-5ddc-8d6e276a3a00/sm"
        alt="Tora Avatar"
        className="w-full h-full object-cover"
      />
    </div>
  );
};

export default ToraAvatar;
